import React, { useCallback, useState } from "react";

import { Button, InputGroup } from "@blueprintjs/core";
import ActionCards from "components/projects/actions/ActionCards";
import ActionsDialog from "components/projects/actions/ActionsDialog";
import ProjectMenu from "components/projects/ProjectMenu";

export default function ProjectActionsPage() {
    const [isOpen, setIsOpen] = useState(false);
    const [search, setSearch] = useState("");
    const toggle = useCallback(() => {
        setIsOpen(!isOpen);
    }, [isOpen]);

    return (
        <div className="main-container">
            <ActionsDialog isOpen={isOpen} toggle={toggle} buttonText="Create" />

            <ProjectMenu
                page="actions"
                actions={[<Button key="new-action" icon="new-object" text="New" intent="primary" onClick={toggle} />]}
                actionsCenter={[
                    <InputGroup
                        type="search"
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                        leftIcon="search"
                        placeholder="Search Actions..."
                    />
                ]}
            />
            <ActionCards search={search} />
        </div>
    );
}
